import { config } from '@/config';

export type AuthServiceRoute =
  | '/login'
  | '/register'
  | '/forgot-password'
  | `/reset-password/${string}`
  | '/email/verify';

function normalizeBaseUrl(url: string): string {
  return url.endsWith('/') ? url.slice(0, -1) : url;
}

export function buildAuthServiceUrl(
  path: AuthServiceRoute,
  query?: Record<string, string | undefined>,
): string {
  const baseUrl = normalizeBaseUrl(config.authBase);
  const url = new URL(`${baseUrl}${path}`);

  if (query) {
    Object.entries(query).forEach(([key, value]) => {
      if (value !== undefined && value !== '') {
        url.searchParams.set(key, value);
      }
    });
  }

  return url.toString();
}

export function redirectToAuthService(path: AuthServiceRoute, query?: Record<string, string | undefined>): string {
  const targetUrl = buildAuthServiceUrl(
    path,
    typeof window !== 'undefined' && (path === '/login' || path === '/register')
      ? { ...query, site: window.location.origin }
      : query,
  );

  if (typeof window !== 'undefined') {
    window.location.assign(targetUrl);
  }

  return targetUrl;
}
